import { IAccOpening, ILeagalPerson, ILicenseInfo, IPersonalInfo } from '../src/components';
import { EAccountType, EBankType, ECompanyType, EOpenBankType, EPaymentChannel, IAccountApplySubmit } from './common';
import { EBindStatus } from './lianlian-manage';
import { UploadUserFile } from 'element-plus';
import { EPayeeUserType } from './air-splitting/separate-bills/payeeManagement';
import { IBeneficiary } from '../src/components';

export interface IAccountOpening {
  /** 账户类型 */
  bankType?: EBankType;

  /** 对公账户名 */
  bankAccountName?: string;

  /** 企业开户银行 */
  bankCode?: string;
  /** 企业基本账号 */
  bankNo?: string;
  /** 开户省份code */
  provinceCode?: string;
  /** 开户城市code */
  cityCode?: string;
  /** 自动匹配的开户支行code */
  cnapsCode?: string;
  /** 自动匹配的开户支行name */
  relationBranchBankNameWithBC?: string;
  /** 手动填写的开户支行name */
  bankBranch?: string;
  /**
   * 开户支行是否手动填写： 1-是，0-否
  */
  customStatus?: 1 | 0;
  /** 支付密码 */
  payPassword?: string;
   /** 随机因子 */
  randomKey?: string;
  /** 连连Id */
  lianId?: string;
    /** 开户银行名称 */
  brabankName?: string;
  /** 手动填写的开户支行name */
  customBankBranchName?: string;
  /** 自动匹配的开户支行name */
  relationBranchBankName?: string;
  /** 自动匹配的开户支行行号 */
  bankBranchNo?: string;
  /** 银行预留手机号 */
  phoneNo?: string;
  /** 验证码 */
  code: string;
}

export interface IBankApplication {
  /** 连连账户id */
  lianId?: number;
  /** 对公账户名 */
  bankAccountName?: string;
  /** 企业用户基本户账户 */
  bankNo?: string;
  /** 银行编码 */
  bankCode?: string;
  /** 银行卡类型 */
  bankType?: EBankType;
  /** 	省编码 */
  provinceCode?: string;
  /** 市编码 */
  cityCode?: string;
  /** 对公账户开户行号/大额行号 */
  cnapsCode?: string;
  /** 对公账户开户行名 */
  brabankName?: string;
  /** 开户支行名称 */
  bankBranch?: string;
  /** 支行信息是否自定义(0:否,1:是) */
  customStatus?: number;
  /** 密码 */
  payPassword?: string;
  /** 密码随机因子key */
  randomKey?: string;
  /** 手机号 */
  linkedPhone?: string;

  [key: string]: any;
}

export interface ILianlianCard {
  /** 连连id */
  lianId: number;
  /** 连连用户编号 */
  lianNo: string;
  /** 开户名称 */
  bankAccountName: string;
  /** 可用余额 */
  availableBalance?: number;
  /**
   * 连连卡包状态
   * @description {@link ELianlianCardStatus }
   */
  accountStatus?: ELianlianCardStatus;
  /** 冻结金额 */
  frozenBalance?: number;
  /** 失败原因 */
  remark?: string;
  /** 注册手机号 */
  regPhone?: string;
  /** 法人手机号 */
  legalPhone?: string;
  /** 待意愿确认链接 */
  openAccountWillUrl?: string;
}

export interface IMyWalletsParam {
  /** 代理商编号 */
  agentNo?: string;
  /** 代理商名称 */
  agentId?: number;
  /** 支付通道 */
  channelType?: EPaymentChannel;
  /** 预充值账户状态  1:正常 2:低 */
  preRechargeStatus?: 1 | 2;
  /** 当前页码（从1开始） */
  page?: number;
  /** 每页显示条数 */
  size?: number;
}

export interface IMyWalletDetail {
  /** 失败原因 */
  remark?: string;
  /** 账户状态 */
  accountStatus?: ELianlianCardStatus;
  /** 通道状态 */
  productConfigStatus?: 0 | 1;
  /** 银行卡号 */
  bankNo?: string;
  /** 手机号 */
  regPhone?: string;
  /** lianlian no */
  lianNo?: string;
  /** lianlian id */
  lianId?: number;
  /** yibao id */
  yopId?: number;
  /** 代理商编号 */
  agentNo: string;
  /** 代理商名称 */
  name: string;
  /**
   * 通道类型
   * @description {@link EPaymentChannel }
   */
  channelType: EPaymentChannel;
  /** 通道费率 */
  rateNum?: number;
  /** 待结算金额 */
  pendingSettlement?: number;
  /** 可提现金额 */
  withDrawable?: number;
  /** 提现冻结金额 */
  withdrawalFreeze?: number;
  /** 本月退款金额 */
  refundAmount?: number;
  /** 企业通道配置id */
  companyChannelConfigId?: number;
  /** 待意愿确认链接 */
  openAccountWillUrl?: string;
}

export interface IMyWalletListItem {
  id: number;
  /** 关联id  易宝/连连 */
  relatedAccountId?: number;
  /** 代理商编号 */
  agentNo: string;
  /** 代理商id */
  agentId: number;
  /** 代理商名称 */
  name: string;
  /**
   * 通道类型
   * @description {@link EPaymentChannel }
   */
  channelType: EPaymentChannel;
  /** 通道费率 */
  rateNum?: number;
  /** 待结算金额 */
  pendingSettlement?: number;
  /** 可提现金额 */
  withDrawable?: number;
  /** 本月退款金额 */
  refundAmount?: number;
  /** 预充值账户金额 */
  preRechargeAmount?: number;
  /** 预充值账户状态 1:正常 2:低 */
  preRechargeStatus?: 1 | 2;
  /** 预警阀值 */
  thresholdBalance?: number;
}

/** 连连开户状态 */
export enum ELianlianCardStatus {
  /** 待审核 */
  CHECK_PENDING = 'CHECK_PENDING',
  /** 待开户 */
  ACTIVATE_PENDING = 'ACTIVATE_PENDING',
  /** 待意愿确认 */
  ACTIVATE_PENDING_NEW = 'ACTIVATE_PENDING_NEW',
  /** 审核通过，待打款验证 */
  REMITTANCE_VALID_PENDING = 'REMITTANCE_VALID_PENDING',
  /** 审核失败 */
  CHECK_REJECT = 'CHECK_REJECT',
  /** 正常 */
  NORMAL = 'NORMAL',
  /** 已销户 */
  CANCEL = 'CANCEL',
}

export const lianCardStatusLabel = {
  [ELianlianCardStatus.CHECK_PENDING]: '审核中',
  [ELianlianCardStatus.ACTIVATE_PENDING]: '待申请',
  [ELianlianCardStatus.ACTIVATE_PENDING_NEW]: '待意愿确认',
  [ELianlianCardStatus.REMITTANCE_VALID_PENDING]: '已开通',
  [ELianlianCardStatus.NORMAL]: '已开通',
  [ELianlianCardStatus.CHECK_REJECT]: '审核失败',
  [ELianlianCardStatus.CANCEL]: '已注销',
};

export const lianCardStatusStyle = {
  [ELianlianCardStatus.CHECK_PENDING]: 'primary',
  [ELianlianCardStatus.ACTIVATE_PENDING]: 'primary',
  [ELianlianCardStatus.ACTIVATE_PENDING_NEW]: 'primary',
  [ELianlianCardStatus.REMITTANCE_VALID_PENDING]: 'success',
  [ELianlianCardStatus.NORMAL]: 'success',
  [ELianlianCardStatus.CHECK_REJECT]: 'danger',
  [ELianlianCardStatus.CANCEL]: 'danger',
};

/** 来账通开户状态 */
export enum ELZTCardStatus {
  /** 待开户 */
  PENDING = 'PENDING',
  /** 待开户意愿确认 */
  WAIT_SIGN = 'WAIT_SIGN',
  /** 审核失败 */
  FAIL = 'FAIL',
  /** 正常 */
  NORMAL = 'NORMAL',
  /** 已销户 */
  CANCEL = 'CANCEL',
}

export const lianlianStatusLabel = {
  [ELianlianCardStatus.CHECK_PENDING]: '待审核',
  [ELianlianCardStatus.ACTIVATE_PENDING]: '待开户',
  [ELianlianCardStatus.ACTIVATE_PENDING_NEW]: '待意愿确认',
  [ELianlianCardStatus.REMITTANCE_VALID_PENDING]: '审核通过，待打款验证',
  [ELianlianCardStatus.CHECK_REJECT]: '审核失败',
  [ELianlianCardStatus.NORMAL]: '正常',
  [ELianlianCardStatus.CANCEL]: '已销户',
};

/** 连连免密授权状态 */
export enum ELianlianPayAuthStatus {
  /** 未授权 */
  Pending = 'Pending',
  /** 已授权 */
  Enabled = 'Enabled',
  /** 授权过期 */
  Disabled = 'Disabled',
}

export enum ELianLianAccountStatus {
  /** 已禁用 */
  Disabled = 'DISABLED',
  /** 已启用 */
  Enabled = 'ENABLED',
  /** 待申请 */
  UnderApplying = 'PENDING',
  /** 待验证 */
  UnderVerifyed = 'WAIT_SIGN',
  /** 申请中 */
  Applying = 'CHECK',
  /** 申请失败 */
  ApplyFailed = 'FAIL',
  /** 待免密授权 */
  UnderNonPassAuth = 'AUTHORIZING',
  /** 免密授权过期 */
  NonPassAuthOutDate = 'AUTHORIZATION_EXPIRED',
  /** 已注销 */
  LoggedOut = 'CANCEL',
}

export const lianlianAccountStatusLabel = {
  [ELianLianAccountStatus.Disabled]: '已禁用',
  [ELianLianAccountStatus.Enabled]: '已开通',
  [ELianLianAccountStatus.Applying]: '申请中',
  [ELianLianAccountStatus.ApplyFailed]: '申请失败',
  [ELianLianAccountStatus.UnderApplying]: '待申请',
  [ELianLianAccountStatus.UnderVerifyed]: '待验证',
  [ELianLianAccountStatus.UnderNonPassAuth]: '待授权',
  [ELianLianAccountStatus.NonPassAuthOutDate]: '授权过期',
  [ELianLianAccountStatus.LoggedOut]: '已注销',
};

export const lianlianAccountStatusOpts = [
  {
    value: ELianLianAccountStatus.Disabled,
    label: lianlianAccountStatusLabel[ELianLianAccountStatus.Disabled],
  },
  {
    value: ELianLianAccountStatus.Enabled,
    label: lianlianAccountStatusLabel[ELianLianAccountStatus.Enabled],
    disabled: true,
  },
  {
    value: ELianLianAccountStatus.UnderApplying,
    label: lianlianAccountStatusLabel[ELianLianAccountStatus.UnderApplying],
  },
  {
    value: ELianLianAccountStatus.UnderVerifyed,
    label: lianlianAccountStatusLabel[ELianLianAccountStatus.UnderVerifyed],
  },
  {
    value: ELianLianAccountStatus.Applying,
    label: lianlianAccountStatusLabel[ELianLianAccountStatus.Applying],
  },
  {
    value: ELianLianAccountStatus.ApplyFailed,
    label: lianlianAccountStatusLabel[ELianLianAccountStatus.ApplyFailed],
  },
  {
    value: ELianLianAccountStatus.UnderNonPassAuth,
    label: lianlianAccountStatusLabel[ELianLianAccountStatus.UnderNonPassAuth],
  },
  {
    value: ELianLianAccountStatus.NonPassAuthOutDate,
    label: lianlianAccountStatusLabel[ELianLianAccountStatus.NonPassAuthOutDate],
  },
  {
    value: ELianLianAccountStatus.LoggedOut,
    label: lianlianAccountStatusLabel[ELianLianAccountStatus.LoggedOut],
  },
];

export const lianlianAccountStatusStyle = {
  [ELianLianAccountStatus.Disabled]: 'info',
  [ELianLianAccountStatus.Enabled]: 'success',
  [ELianLianAccountStatus.Applying]: 'warning',
  [ELianLianAccountStatus.ApplyFailed]: 'danger',
  [ELianLianAccountStatus.UnderApplying]: 'warning',
  [ELianLianAccountStatus.UnderVerifyed]: 'warning',
  [ELianLianAccountStatus.UnderNonPassAuth]: 'primary',
  [ELianLianAccountStatus.NonPassAuthOutDate]: 'info',
  [ELianLianAccountStatus.LoggedOut]: 'info',
};

export interface ICnapsCode {
  cnaps_code: string;
  brabank_name: string;
}

export enum ELianLianStepKey {
  License = 'license',
  Legal = 'legal',
  AccOpening = 'accOpening',
  Beneficiary = 'beneficiary',
  Store = 'store',
  Submit = 'submit',
  Submited = 'submited',
}

/** 分账账户表单第3步 */
export interface ILianAccApplySubmit extends IAccountApplySubmit {}

/** 连连管理 - detail */
export interface ILianDetail extends ILicenseInfo, ILeagalPerson, IAccOpening {
  id?: number;
  /**
   * 企业类型：企业-ENTERPRISE, 个体工商户-PROPRIETOR
   * @description {@link ECompanyType}
   */
  type?: ECompanyType;
  /**
   * 连连统一社会信用代码证照片和企业法人身份证照片上传照片状
   * @description 0:未上传、1：已上传
   */
  uploadStatus?: 0 | 1;
  /** 业务联系人区域id */
  regionId?: string;
  /** 业务联系人详细地址 */
  detailAddress?: string;
  /**
   * 账号类型
   * @description {@link EAccountType}
   */
  accountType?: EAccountType;
  /** 开户状态(0:未去开户、1：已经去开户) */
  lianStatus?: 0 | 1;
  /** 连连绑定手机号状态(0:绑定中,1:绑定成功) */
  bindingPhoneStatus?: 0 | 1;
  /**
   * 账号状态
   * * @description {@link ELianlianCardStatus}
   */
  accountStatus?: ELianlianCardStatus;
  /**
   * 新网银行：xwbank 厦门国际银行：xib
   * @description {@link EOpenBankType}
   */
  openBank?: EOpenBankType;
  /** 银行卡号 */
  bankAcctNo?: string;
  /** 联行号 */
  brbankNo?: string;
  /** 收款账户/合作银行账号 */
  bankAccount?: string;
  /** 绑定手机号 */
  regPhone?: string;
  /** 行业代码 */
  industryCode?: string;
  /** 注册资本 */
  registeredCapital?: string;
  /** 交易流水号 */
  txnSeqno?: string;
  /** 备注 */
  remark?: string;
  /** 申请日期 */
  applyDate?: string;
  /** 通过日期 */
  passDate?: string;
  /** 企业id */
  companyId?: string;
  /** 企业通道配置ID */
  payerId?: string;
  /** 费率 */
  settleServiceRate?: string;
  /**
   * 免密授权数据
   * @description {@link INonePassLianSign}
   */
  lianSign?: INonePassLianSign;
  /** 收费类型：入账收费-1 */
  feeType?: '1';
  /**
   * 开户表单信息
   * @description {@link ILianBank}
   */
  lianBank?: ILianBank;
  /**
   * 受益人信息
   * @description {@link IBeneficiary}
   */
  uboList?: IBeneficiary[];

  /**
   * 收款方个人基本信息
   * @description {@link IPersonalInfo}
   */
  personalPayeeInfo?: IPersonalInfo;

  /** 店铺模板 */
  certTemplateUrl?: string;
  /**
   * 店铺列表
   * @description {@link ILztStore}
   */
  lztList?: ILztStore[];
  /**
   * 来账通账户状态
   * @description {@link ELZTCardStatus}
   */
  lztStatus?: ELZTCardStatus;
  /** 来账开户行行号 */
  lztBankNo?: string;
  /** 来账通开户行名 */
  lztBankName?: string;
  /** 来账通开户行城市 */
  lztBankCity?: string;
  /** 来账通开户银行(行别) */
  lztBank?: string;

  payeeId?: string;
  payeeNo?: number;
  /** 用户类型 */
  payeeType?: EPayeeUserType;
}

/** 免密授权数据 */
export interface INonePassLianSign {
  lianId?: number;
  /** 委托代发协议号 */
  papAgreeNo?: string;
  /** 授权开始时间(yyyyMMdd) */
  signStartTime?: string;
  /** 授权结束时间(yyyyMMdd) */
  signInvalidTime?: string;
  /** 委托代扣单笔最大交易额度 */
  singleLimit?: string;
  /** 委托代扣每日最大交易额度 */
  dailyLimit?: string;
  /** 委托代扣每月最大交易额度 */
  monthlyLimit?: string;
  /**
   * 协议状态(Enabled:协议有效，可进行免密代扣或代发,Disabled:协议过有效期导致失效,Cancel:用户主动注销协议)
   * @description {@link EProtocolStatus}
  */
  status?: EProtocolStatus;
}

/** 协议状态 */
export enum EProtocolStatus {
  /** 协议有效，可进行免密代扣或代发 */
  Enabled = 'Enabled',
  /** 协议过有效期导致失效 */
  Disabled = 'Disabled',
  /** 用户主动注销协议 */
  Cancel = 'Cancel',
}

/** 来账通店铺信息 */
export interface ILztStore {
  lianId: number;
  lianNo?: string;
  /** 是否选中 */
  selected?: boolean;
  /**
   * 来账通店铺业务类型
   * @description {@link ELztBusinessType}
   */
  businessType?: ELztBusinessType;
  /** 电商平台店铺id */
  shopId?: string;
  /** 店铺首页截图url */
  shopPicUrl?: string;
  /** 店铺首页截图类型 */
  shopPicType?: string;
  /** 后台订单截图/GVM截图url */
  tradePicUrl?: string;
  /** 后台订单截图/GVM截图类型 */
  tradePicType?: string;
  /** 电商平台地址 */
  shopName?: string;
  /** 店铺商品地址 */
  shopAddress?: string;
  /** 店铺详细地址 */
  shopDetailAddress?: string;
  /** 数字证书 */
  certificateUrl?: string;
  /** 省份编码 */
  province?: string;
  /** 城市编码 */
  city?: string;
  /** 区编码 */
  area?: string;
  /** 来账通备注 */
  memo?: string;
  /**
   * 提交的时候要删除
   * @description {@link UploadUserFile}
   */
  fileList?: UploadUserFile[];
}

export interface ILianBank {
  /**
   * 银行卡类型
   * @description {@link EBankType}
   */
  bankType?: EBankType;
  /**
   * 连连卡绑定状态
   * @description {@link EBindStatus}
   */
  bankStatus?: EBindStatus;
  /** 对公账户名 */
  bankAccountName?: string;
  /** 企业基本账号 */
  bankNo?: string;
  /** 开户银行名称 */
  brabankName?: string;
  /** 开户支行名称 */
  bankBranch?: string;
  /** 开户银行code */
  bankCode?: string;
  /** 开户支行行号/大额行号 */
  cnapsCode?: string;
  /** 开户省份code */
  provinceCode?: string;
  /** 开户城市code */
  cityCode?: string;
  /** 区编码 */
  areaCode?: string;
  /** 备注 */
  remark?: string;
  /** 交易流水号 */
  txnSeqno?: string;
  /** ACCP系统交易单号 */
  accpTxno?: string;
  /** 绑卡协议号 */
  linkedAgrtno?: string;
  /** 信用卡 cvv2 */
  cvv2?: string;
  /** 版本号 */
  version?: string;
  /** 信用卡有效期 */
  validThru?: string;
  /** 银行预留手机号 */
  linkedPhone?: string;
  /** 支行信息是否自定义(0:否,1:是) */
  customStatus?: 0 | 1;

  type?: ECompanyType;
}

/** 来账通店铺业务类型 */
export enum ELztBusinessType {
  /** 抖音 */
  DOUYIN = 'DOUYIN',
  /** 快手 */
  KUAISHOU = 'KUAISHOU',
  /** 拼多多 */
  PINDUODUO = 'PINDUODUO',
  /** 小红书 */
  XIAOHONGSHU = 'XIAOHONGSHU',
  /** 视频号 */
  SHIPINHAO = 'SHIPINHAO',
  /** 淘宝 */
  TAOBAO = 'TAOBAO',
  /** 天猫 */
  TIANMAO = 'TIANMAO',
  /** 京东 */
  JINGDONG = 'JINGDONG',
}

export const lztBussinessTypeName = {
  [ELztBusinessType.DOUYIN]: '抖音',
  [ELztBusinessType.KUAISHOU]: '快手',
  [ELztBusinessType.PINDUODUO]: '拼多多',
  [ELztBusinessType.XIAOHONGSHU]: '小红书',
  [ELztBusinessType.SHIPINHAO]: '视频号',
  [ELztBusinessType.TAOBAO]: '淘宝',
  [ELztBusinessType.TIANMAO]: '天猫',
  [ELztBusinessType.JINGDONG]: '京东',
};

export const lztBussinessTypes = [
  {
    label: '抖音',
    value: ELztBusinessType.DOUYIN,
  },
  {
    label: '快手',
    value: ELztBusinessType.KUAISHOU,
  },
  {
    label: '拼多多',
    value: ELztBusinessType.PINDUODUO,
  },
  {
    label: '小红书',
    value: ELztBusinessType.XIAOHONGSHU,
  },
  {
    label: '视频号',
    value: ELztBusinessType.SHIPINHAO,
  },
  {
    label: '淘宝',
    value: ELztBusinessType.TAOBAO,
  },
  {
    label: '天猫',
    value: ELztBusinessType.TIANMAO,
  },
  {
    label: '京东',
    value: ELztBusinessType.JINGDONG,
  },
];

export interface IPreRecharge {
  /* 代理商Id */
  agentId: number;
  /* 类型 1:预充值 2:预警阀值 */
  type: number;
  /* 金额 */
  money: number;
}

export interface IRechargeItem {
  /** 充值编号 */
  orderNo: string;
  /** 充值前 */
  rechargeBeforeBalance: number;
  /** 充值后 */
  rechargeAfterBalance: number;
  /** 充值金额 */
  rechargeAmount: number;
  /** 操作人 */
  creator: string;
  /** 充值时间 */
  createTime: string;
}

export interface IConsumptionItem {
  /** 充值编号 */
  orderNo: string;
  /** 消费类型 */
  purchaseType: string;
  /** 支付通道 */
  payChannel: string;
  /** 企业名称 */
  companyName: string;
  /** 消耗金币 */
  amount: number;
  /** 操作人 */
  creator: string;
  /** 消耗时间 */
  createTime: string;
}
